import { FETCH_CSS_INFO_SUCCESS } from "./actionTypes";

const initialState = {
    data: '',
};

const cssInformationListR = (state = initialState, action) => {
    
    switch (action.type) {
        case FETCH_CSS_INFO_SUCCESS:
            // state.data = action.payload.response;
            state = { ...state, data: action.payload.response };
            return state;
    }
    return state;
}

export default cssInformationListR